module.exports = __webpack_public_path__ + "img/icon_map_11_off_100.f4da21e2.png";